// GridReceivables.jsx (Refatorado)
import { format, parseISO } from "date-fns";
import { useEffect, useMemo, useState } from "react";
import { USDollar } from "~/functions";
import useReportsStore from "~/store/reportsSectionStore";
import AccountRow from "../accountRow";
import ReceivablesModal from "../../Financial/Receivables/receivablesModal";

export default function GridReceivables({ data, selectedPaymentMethodId = "", selectedStatus = "" }) {
  if (!data) return null;
  const [firstLevelIndex, setFirstLevelIndex] = useState(null);
  const { chartOfAccountSelected, setChartOfAccountSelected } =
    useReportsStore();
  const { filters } = useReportsStore();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const dateTypeParam = useMemo(() => {
    const label = filters?.period_by?.label || filters?.period_by?.value || "";
    const map = {
      "Due Date": "due_date",
      "Settlement Date": "settlement_date",
      "Competence Date": "competence_date",
    };
    return map[label] || label?.toLowerCase()?.replace(/\s+/g, "_");
  }, [filters?.period_by]);

  useEffect(() => {
    if (!chartOfAccountSelected) {
      setFirstLevelIndex(null);
    } else {
      setFirstLevelIndex(0);
    }
  }, [chartOfAccountSelected]);

  return (
    <div
      id="grid"
      className="flex w-full flex-1 flex-col justify-center items-center mt-4 select-none overflow-x-scroll"
    >
      {/* Removed header controls; filtering close moved into the detail chart */}
      <div className="flex w-full flex-row items-center justify-start">
        <table className="w-full text-center text-xs text-zinc-500 rounded-lg overflow-hidden shadow-xs">
          <tr className="bg-zinc-100 text-zinc-950">
            <td className="min-w-[250px] text-left font-bold border-b p-2 sticky left-0 bg-zinc-100">
              Chart of Accounts
            </td>
            {data?.periods?.map((item, index) => (
              <td className="font-bold border-b p-2" key={index}>
                {format(parseISO(item.period + "-01"), "MMM/yyyy")}
              </td>
            ))}
          </tr>
          {data?.byChartOfAccount
            ?.filter(
              (item) =>
                !chartOfAccountSelected || item.code === chartOfAccountSelected
            )
            ?.filter(
              (item) => item.periods.reduce((acc, period) => acc + period.total, 0) > 0
            )
            ?.map((item, index) => (
              <AccountRow
                key={index}
                item={item}
                index={index}
                firstLevelIndex={firstLevelIndex}
                setFirstLevelIndex={setFirstLevelIndex}
                onCellClick={({ account, parent, period, periodIndex, value, level }) => {
                  const accountLabel = `${account.code} ${account.name}`;
                  const labelWithParent = parent ? `${parent.code} ${parent.name} > ${accountLabel}` : accountLabel;
                  setModalData({
                    accountLabel: labelWithParent,
                    code: account.code,
                    name: account.name,
                    period: period?.period,
                    from: period?.from,
                    to: period?.to,
                    value: value,
                    dateType: dateTypeParam,
                    level,
                    paymentMethodIds: selectedPaymentMethodId || "all",
                    statuses: selectedStatus || "all",
                  });
                  setModalOpen(true);
                }}
              />
            ))}
        </table>
      </div>

      <ReceivablesModal isOpen={modalOpen} onClose={() => setModalOpen(false)} modalData={modalData} />
    </div>
  );
}
